import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import Route from './Route';

import Error404 from '~/pages/_error404';
import SignIn from '~/pages/SignIn';
import SignUp from '~/pages/SignUp';
import Recovery from '~/pages/Recovery';
import RecoveryUpdate from '~/pages/RecoveryUpdate';

import Dashboard from '~/pages/Home';
import Project from '~/pages/Project';
import ProjectDetails from '~/pages/Project/Details';
import ProjectDashboard from '~/pages/Project/Dashboard';
import ProjectTeam from '~/pages/ProjectTeam';
import Schedule from '~/pages/Schedule';
import Sprint from '~/pages/Sprint';
import ReportCompletedWork from '~/pages/Report/CompletedWork';
import ReportDailyHour from '~/pages/Report/DailyHour';
import MailSend from '~/pages/Mail/Send';

export default function Routes() {
  return (
    <Switch>
      <Route path="/login" exact component={SignIn} />
      <Route path="/recovery" exact component={Recovery} />
      <Route path="/recovery/:token" exact component={RecoveryUpdate} />
      <Route path="/register" exact component={SignUp} />
      <Route path="/404" exact component={Error404} />

      <Route path="/" exact component={Dashboard} isPrivate />
      <Route path="/projects" exact component={Project} isPrivate />
      <Route path="/projects/:id" exact component={ProjectDashboard} isPrivate />
      <Route path="/projects/:id/dashboard" exact component={ProjectDashboard} isPrivate />
      <Route path="/projects/:id/backlog" exact component={ProjectDetails} isPrivate />
      <Route path="/projects/:id/features" exact component={ProjectDetails} isPrivate />
      <Route path="/projects/:id/epics" exact component={ProjectDetails} isPrivate />
      <Route path="/projects/:projectId/teams" exact component={ProjectTeam} isPrivate />
      <Route path="/projects/:projectId/sprints/:id" exact component={Sprint} isPrivate />
      <Route path="/projects/:projectId/sprints/:id/tasks/:idTask" exact component={Sprint} isPrivate />
      <Route path="/projects/:id/repositories" exact component={ProjectDetails} isPrivate />
      <Route path="/schedule" exact component={Schedule} isPrivate />
      <Route path="/mails" exact component={MailSend} isPrivate />

      <Route path="/report/completedwork" exact component={ReportCompletedWork} isPrivate />
      <Route path="/report/dailyhours" exact component={ReportDailyHour} isPrivate />

      <Redirect to="/404" />
    </Switch>
  );
}